<template>
    <div class="modal fade" id="cannotDelete" tabindex="-1" role="dialog" aria-labelledby="confirmSingleDeleteProduct" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content campaign-g-addedit">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">{{headerMsg}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>{{deleteMessage ? deleteMessage : 'Cannot delete as part of campaign'}}</p>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">OK</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'CannotDeletePopUp',
    data() {
        return {

        }
    },
    props: {
		deleteMessage : {
			type: String,
			default: 'Cannot Delete as already added to a campaign'
		},
		headerMsg : {
			type: String,
			default: 'Delete'
		}
    },
	mounted(){
		//
		if(this.deleteMessage == ""){
			this.$emit("ProvideVal")
		}
	},
    methods: {

    },
}
</script>

<style lang="scss">

</style>
